import {Component, OnInit, OnDestroy} from "@angular/core";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";

import {
  CommonService,
  AlertService,
  AdminService,
  ProjectService,
  ProfileService,
} from "../../../_services/";
import {Subscription} from "rxjs";
import {de} from "date-fns/locale";
// import { copyFileSync } from 'fs';

@Component({
  selector: "app-settings",
  templateUrl: "./settings.component.html",
  styleUrls: ["./settings.component.scss"],
})
export class SettingsComponent implements OnInit {
  systemForm: FormGroup;
  systemURL: {
    id: String;
    base_url: String;
    referral_base_url: String;
    referral_base_url_error: String;
    trade_account_base_url: String;
  }[] = [];
  baseURL: String;
  referralBaseUrl: String;
  referralBaseUrlError: String;
  tradeAccountBaseUrl: String;
  submitted: Boolean = false;
  errMsg: String = "";
  successMsg: String = "";
  projectList: any[] = [];
  private subscription: Subscription;
  constructor(
    private fb: FormBuilder,
    private _common: CommonService,
    private _admin: AdminService,
    private _alert: AlertService,
    private _project: ProjectService
  ) {}

  ngOnInit() {
    // setTimeout(()=>{
    // this.matchNodeData();
    // },2000);
    this.getSystemUrls();
    this.systemForm = this.fb.group({
      base_url: [null, []],
      referral_base_url: [null, []],
      referral_base_url_error: [null, []],
      trade_account_base_url: [null, []],
      form_base_url: [null, []],
      email_system_wide: ["", []],
      project_map_steps_override: ["", []],
      mode: ["", []],
    });
  }

  getSystemUrls() {
    this._common.showLoader(true);
    this.subscription = this._admin.geSystemUrls().subscribe(
      (result) => {
        this._common.showLoader(false);
        for (let i = 0; i < result.length; i++) {
          this.systemURL.push({
            id: result[i].payload.doc.id,
            ...result[i].payload.doc.data(),
          });
        }

        if (this.systemURL.length > 0) {
          this.systemForm.patchValue({
            base_url:
              this.systemURL.filter((item) => item.id == "base_url").length > 0
                ? this.systemURL.filter((item) => item.id == "base_url")[0]
                    .base_url
                : "",
            referral_base_url: this.systemURL.filter(
              (item) => item.id == "referral_base_url"
            )[0].referral_base_url,
            referral_base_url_error: this.systemURL.filter(
              (item) => item.id == "referral_base_url_error"
            )[0].referral_base_url_error,
            trade_account_base_url: this.systemURL.filter(
              (item) => item.id == "trade_account_base_url"
            )[0].trade_account_base_url,
            form_base_url: this.systemURL.filter(
              (item) => item.id == "form_base_url"
            )[0]["form_base_url"],
            email_system_wide: this.systemURL.filter(
              (item) => item.id == "email_system_wide"
            )[0]["email_system_wide"],
            project_map_steps_override: this.systemURL.filter(
              (item) => item.id == "project_map_steps_override"
            )[0]["project_map_steps_override"],
            mode: this.systemURL.filter((item) => item.id == "mode")[0]["mode"],
          });
        }
      },
      (err) => {
        this._common.showLoader(false);
        this._alert.error(
          err.error.message ? err.error.message : "Something went wrong!"
        );
      }
    );
  }

  onFormSubmit() {
    this.submitted = true;
    if (this.systemForm.invalid) {
      return;
    }
    let form = this.systemForm.value;
    this._common.showLoader(true);
    // update base url...
    this._admin.updateSystemUrl({base_url: form.base_url}, "base_url").then(
      (res) => {
        // update referral_base_url...
        this._admin
          .updateSystemUrl(
            {referral_base_url: form.referral_base_url},
            "referral_base_url"
          )
          .then(
            (res) => {
              // update referral_base_url_error
              this._admin
                .updateSystemUrl(
                  {referral_base_url_error: form.referral_base_url_error},
                  "referral_base_url_error"
                )
                .then(
                  (res) => {
                    // update trade_account_base_url
                    this._admin
                      .updateSystemUrl(
                        {trade_account_base_url: form.trade_account_base_url},
                        "trade_account_base_url"
                      )
                      .then(
                        (res) => {
                          // update system wide email
                          this._admin
                            .updateSystemUrl(
                              {email_system_wide: form.email_system_wide},
                              "email_system_wide"
                            )
                            .then(
                              (res) => {
                                this._admin
                                  .updateSystemUrl(
                                    {
                                      project_map_steps_override:
                                        form.project_map_steps_override,
                                    },
                                    "project_map_steps_override"
                                  )
                                  .then(
                                    (res) => {
                                      this._admin
                                        .updateSystemUrl(
                                          {mode: form.mode},
                                          "mode"
                                        )
                                        .then((res) => {
                                          this._admin
                                            .updateSystemUrl(
                                              {
                                                form_base_url:
                                                  form.form_base_url,
                                              },
                                              "form_base_url"
                                            )
                                            .then((res) => {
                                              this._common.showLoader(false);
                                              this.successMsg =
                                                "System settings updated successfully!";
                                              this.systemForm.patchValue({
                                                base_url: form.base_url,
                                                referral_base_url:
                                                  form.referral_base_url,
                                                referral_base_url_error:
                                                  form.referral_base_url_error,
                                                trade_account_base_url:
                                                  form.trade_account_base_url,
                                                form_base_url:
                                                  form.form_base_url,
                                                email_system_wide:
                                                  form.email_system_wide,
                                                project_map_steps_override:
                                                  form.project_map_steps_override,
                                                mode: form.mode,
                                              });
                                            })
                                            .catch((err) => {
                                              this._common.showLoader(false);
                                              this.errMsg =
                                                "Something went wrong";
                                            });
                                        })
                                        .catch((err) => {
                                          this._common.showLoader(false);
                                          this.errMsg = "Something went wrong";
                                        });
                                    },
                                    (err) => {
                                      this._common.showLoader(false);
                                      this.errMsg = "Something went wrong";
                                    }
                                  );
                              },
                              (err) => {
                                this._common.showLoader(false);
                                this.errMsg = "Something went wrong";
                              }
                            );
                        },
                        (err) => {
                          this._common.showLoader(false);
                          this.errMsg = "Something went wrong";
                        }
                      );
                  },
                  (err) => {
                    this._common.showLoader(false);
                    this.errMsg = "Something went wrong";
                  }
                );
            },
            (err) => {
              this._common.showLoader(false);
              this.errMsg = "Something went wrong";
            }
          );
      },
      (err) => {
        this._common.showLoader(false);
        this.errMsg = "Something went wrong";
      }
    );
  }

  capitalizeFirstLetter(string) {
    if (string && string.length > 0) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    } else {
      return string;
    }
  }

  // matchNodeData1(){
  //   this._common.showLoader(true);
  //   this._project.getProjectMapNode1().subscribe(nodes=>{
  //     console.log(nodes.length,'nodes length!!!!!');
  //     this._common.showLoader(false);
  //   }, err =>{
  //     this._common.showLoader(false);
  //     console.log('error occured while couting nodes!');
  //   })
  // }
  /*
  // Match project_map_node collection data
  matchNodeData(designer_id = ""){
    const idArr = [];
    this._common.showLoader(true);
    if(designer_id === ""){
      this._admin.getAllProjects().subscribe(res=>{
        console.log(res.length,'total project length!!!!');
        for(let i=5801; i<=5999; i++){ //5000 + 2000 + 2000, + 2000 > LAst 5600 record checked for nodes issue
          let projectData = res[i].payload.doc.data()['rs2'];
          // Fetch data from project_map_nodes for current project...
          this._project.getProjectMapNode(projectData.nid).subscribe(nodes=>{
            if(nodes.length >0){
            // Check desired production week  
            console.log(nodes[0].payload.doc.data()['project_id'],'nodes length', nodes.length,'---------',i);
            const desiredProductionWeekIndex = nodes.findIndex(item=>item.payload.doc.data()['project_map_field_id'] === "pyHdp66THa5G04GAquMr");
            // Requested Production Week
            const requestedProductionWeekIndex = nodes.findIndex(item=>item.payload.doc.data()['project_map_field_id'] === "ffOuAulZqHN3avAzbfi5");

            // Technical Designer
            const TDIndex = nodes.findIndex(item=>item.payload.doc.data()['project_map_field_id'] === "06qKtGZKZdkQ6Ngeq0oO");
            // Size
            const SizeIndex = nodes.findIndex(item=>item.payload.doc.data()['project_map_field_id'] === "16jq0ASz1FsSP2HbRSBb");
            // Accounting Ref#
            const AccountingRefIndex = nodes.findIndex(item=>item.payload.doc.data()['project_map_field_id'] === "2xRks4oV4X2XHFTstXtO");
            // Complexity
            const ComplexityIndex = nodes.findIndex(item=>item.payload.doc.data()['project_map_field_id'] === "8Mwe89gcvBYNuOuurhVe");
            // Brand
            const BrandIndex = nodes.findIndex(item=>item.payload.doc.data()['project_map_field_id'] === "99KrwVmq0xNOnrYs3xoE");
            // Amount of Cabinets
            const AmountofCabinetsIndex = nodes.findIndex(item=>item.payload.doc.data()['project_map_field_id'] === "Aa0mO4IwJOBMq6t46EpL");
            // STEP 4
            // Installation Price
            const InstallationPriceIndex = nodes.findIndex(item=>item.payload.doc.data()['project_map_field_id'] === "KqpQgtO0iLNmLXy1Snv1");
            // Installation Linear Feet
            const InstallationLinearFeetIndex = nodes.findIndex(item=>item.payload.doc.data()['project_map_field_id'] === "QItLAnufGdO32DDttM8Y");
            // Installation Required
            const InstallationRequiredIndex = nodes.findIndex(item=>item.payload.doc.data()['project_map_field_id'] === "Qe60jcBLSkYneVSJHlVO");
            // Appliances Purchased
            const AppliancesPurchasedIndex = nodes.findIndex(item=>item.payload.doc.data()['project_map_field_id'] === "MYk4iyBUC7ov2ulmO82u");
            // STEP 7.5
            // Storage Fee Paid
            const StorageFeePaidIndex = nodes.findIndex(item=>item.payload.doc.data()['project_map_field_id'] === "coSlwfdlYRYfYMI3EwZX");
            // Storage Fee Cost
            const StorageFeeCostIndex = nodes.findIndex(item=>item.payload.doc.data()['project_map_field_id'] === "x2CpEcmvjvmP8LFsnnz7");
            // Step 8
            // Delivery Notes
            const DeliveryNotesIndex = nodes.findIndex(item=>item.payload.doc.data()['project_map_field_id'] === "FFtp0jOX2TKk9PY3ptpF");
            // Step 9
            // Installation Notes
            const InstallationNotesIndex = nodes.findIndex(item=>item.payload.doc.data()['project_map_field_id'] === "kwCZ4fNsd3OD7Ni30mW6");


            if((projectData.field_project_production_week.length === 0 && nodes[desiredProductionWeekIndex].payload.doc.data()["value"] === "") || (projectData.field_project_production_week && projectData.field_project_production_week.und && nodes[desiredProductionWeekIndex].payload.doc.data()["value"] === projectData.field_project_production_week.und[0].value)){
              if((projectData.field_requested_production_week.length ===0 && nodes[requestedProductionWeekIndex].payload.doc.data()['value'] === "") || (projectData.field_requested_production_week.und && nodes[requestedProductionWeekIndex].payload.doc.data()['value'] === projectData.field_requested_production_week.und[0].value)){
                if((projectData.field_project_size.length ===0 && nodes[SizeIndex].payload.doc.data()['value'] === "") || (projectData.field_project_size.und && nodes[SizeIndex].payload.doc.data()['value'] === projectData.field_project_size.und[0].value)){
                  if((projectData.field_project_acc_ref.length===0 && nodes[AccountingRefIndex].payload.doc.data()['value'] === "") || nodes[AccountingRefIndex].payload.doc.data()['value'] == projectData.field_project_acc_ref.und[0].value){
                    if((projectData.field_project_complexity.length === 0 && nodes[ComplexityIndex].payload.doc.data()['value'] ==="") || (projectData.field_project_complexity.und &&  nodes[ComplexityIndex].payload.doc.data()['value'] === projectData.field_project_complexity.und[0].value)){
                      if((projectData.field_project_brand.length === 0 && nodes[BrandIndex].payload.doc.data()['value'] ==="") || (projectData.field_project_brand.und && nodes[BrandIndex].payload.doc.data()['value'] === projectData.field_project_brand.und[0].value)){
                        if((projectData.field_project_amount_of_cabinets.length ===0 && nodes[AmountofCabinetsIndex].payload.doc.data()['value'] === "") || nodes[AmountofCabinetsIndex].payload.doc.data()['value'] === projectData.field_project_amount_of_cabinets.und[0].value){
                          if((projectData.field_project_install_price.length ===0 && nodes[InstallationPriceIndex].payload.doc.data()['value'] === "" ) || nodes[InstallationPriceIndex].payload.doc.data()['value'] === projectData.field_project_install_price.und[0].value){
                            if((projectData.field_installation_linear_feet.length ===0 && nodes[InstallationLinearFeetIndex].payload.doc.data()['value'] === "") || nodes[InstallationLinearFeetIndex].payload.doc.data()['value'] === projectData.field_installation_linear_feet.und[0].value){
                              if((projectData.field_installation_required.length ===0 && nodes[InstallationRequiredIndex].payload.doc.data()['value'] === "") || nodes[InstallationRequiredIndex].payload.doc.data()['value'] === this.capitalizeFirstLetter(projectData.field_installation_required.und[0].value)){
                                if((projectData.field_appliances_purchased.length ===0 && nodes[AppliancesPurchasedIndex].payload.doc.data()['value']==="") || nodes[AppliancesPurchasedIndex].payload.doc.data()['value'] === projectData.field_appliances_purchased.und[0].value){
                                  if((projectData.field_project_storage_fee_paid.length ===0 && nodes[StorageFeePaidIndex].payload.doc.data()['value'] === "") || nodes[StorageFeePaidIndex].payload.doc.data()['value'] === projectData.field_project_storage_fee_paid.und[0].value){
                                    if ((projectData.field_project_storage_fee_cost.length ===0 && nodes[StorageFeeCostIndex].payload.doc.data()['value'] === "") || nodes[StorageFeeCostIndex].payload.doc.data()['value'] === projectData.field_project_storage_fee_cost.und[0].value){
                                      if ((projectData.field_project_delivery_notes.length ===0 && nodes[DeliveryNotesIndex].payload.doc.data()['value'] === "") || nodes[DeliveryNotesIndex].payload.doc.data()['value'] === projectData.field_project_delivery_notes.und[0].value) {
                                        if((projectData.field_project_installation_notes.length ===0 && nodes[InstallationNotesIndex].payload.doc.data()['value'] === "") || nodes[InstallationNotesIndex].payload.doc.data()['value'] === projectData.field_project_installation_notes.und[0].value){
                                          console.log("all Node matched!!!!!!", idArr);
                                        } else {
                                          this._common.showLoader(false);
                                          idArr.push(projectData.nid);
                                          this._alert.error('Installed notes not matching'+projectData.nid);   
                                          throw new Error('This is not an error.  '+projectData.nid);
                                          
                                          
                                        }
                                      } else {
                                        this._common.showLoader(false);
                                        idArr.push(projectData.nid);
                                        this._alert.error('Deliver notes not matching'+projectData.nid); 
                                        throw new Error('This is not an error.  '+projectData.nid);
                                      }
                                    } else {
                                      this._common.showLoader(false);
                                      idArr.push(projectData.nid);
                                      this._alert.error('Storage Fee Cost  not matching'+projectData.nid); 
                                      throw new Error('This is not an error.  '+projectData.nid);
                                    }
                                  } else {
                                    this._common.showLoader(false);
                                    idArr.push(projectData.nid);
                                    this._alert.error('Storage Fee Paid not matching'+projectData.nid); 
                                    throw new Error('This is not an error.  '+projectData.nid);
                                  }
                                } else {
                                  this._common.showLoader(false);
                                  idArr.push(projectData.nid);
                                  this._alert.error('Appliances Purchased not matching'+projectData.nid); 
                                  throw new Error('This is not an error.  '+projectData.nid);
                                }
                              } else {
                                this._common.showLoader(false);
                                idArr.push(projectData.nid);
                                this._alert.error('Installation Required not matching'+projectData.nid); 
                                throw new Error('This is not an error.  '+projectData.nid);
                              }
                            } else {
                              this._common.showLoader(false);
                              idArr.push(projectData.nid);
                              this._alert.error('Installation Linear Feet not matching'+projectData.nid); 
                              throw new Error('This is not an error.  '+projectData.nid);
                            }
  
                          } else {
                            this._common.showLoader(false);
                            idArr.push(projectData.nid);
                            this._alert.error('Installation Price not matching '+projectData.nid);      
                            throw new Error('This is not an error.  '+projectData.nid);
                          }
                        } else {
                          this._common.showLoader(false);
                          idArr.push(projectData.nid);
                          this._alert.error('Amount of cabinet not matching '+projectData.nid);      
                          throw new Error('This is not an error.  '+projectData.nid);
                        }
  
                      } else {
                        this._common.showLoader(false);
                        idArr.push(projectData.nid);
                        this._alert.error('Brand not matching '+projectData.nid);      
                        throw new Error('This is not an error.  '+projectData.nid);
                      }
  
                    } else {
                      this._common.showLoader(false);
                      idArr.push(projectData.nid);
                      this._alert.error('Complexity not matching '+projectData.nid);    
                      throw new Error('This is not an error.  '+projectData.nid);  
                    }
  
                  } else {
                    this._common.showLoader(false);
                    idArr.push(projectData.nid);
                    this._alert.error('Accounting ref not matching '+projectData.nid);   
                    throw new Error('This is not an error.  '+projectData.nid);  
                  }
  
                } else {
                  this._common.showLoader(false);
                  idArr.push(projectData.nid);
                  this._alert.error('size not matching '+projectData.nid);    
                  throw new Error('This is not an error.  '+projectData.nid);  
                }
  
              } else {
                this._common.showLoader(false);
                idArr.push(projectData.nid);
                this._alert.error('desired production week not matching '+projectData.nid); 
                throw new Error('This is not an error.  '+projectData.nid);  
              }
  
            }
            else {
              this._common.showLoader(false);
              idArr.push(projectData.nid);
              this._alert.error('desired production week not matching '+projectData.nid);
              throw new Error('This is not an error.  '+projectData.nid);  
            }
            } else {
              this._common.showLoader(false);
              this._alert.error('No node found for this project id!');
            }


            // return;
          },err =>{
            this._alert.error('Error occured while fetch project map node!');  
          });
        }

      },err=>{
        console.log(err);
        this._alert.error('Error occured while fetching all projects!!');  
      })
    }
    else {
      
      // Fetch all the projects of designer...
      this._project.getDesignerProjects(designer_id).subscribe(res=>{
        if(res.length > 0){
          for(let i=0; i<res.length; i++){
            let projectData = res[i].payload.doc.data()['rs2'];
            // Fetch data from project_map_nodes for current project...
            this._project.getProjectMapNode(projectData.nid).subscribe(nodes=>{
              // Check desired production week  
              if(nodes.length>0){
                const desiredProductionWeekIndex = nodes.findIndex(item=>item.payload.doc.data()['project_map_field_id'] === "pyHdp66THa5G04GAquMr");
                // Requested Production Week
                const requestedProductionWeekIndex = nodes.findIndex(item=>item.payload.doc.data()['project_map_field_id'] === "ffOuAulZqHN3avAzbfi5");
                // Technical Designer
                const TDIndex = nodes.findIndex(item=>item.payload.doc.data()['project_map_field_id'] === "06qKtGZKZdkQ6Ngeq0oO");
                // Size
                const SizeIndex = nodes.findIndex(item=>item.payload.doc.data()['project_map_field_id'] === "16jq0ASz1FsSP2HbRSBb");
                // Accounting Ref#
                const AccountingRefIndex = nodes.findIndex(item=>item.payload.doc.data()['project_map_field_id'] === "2xRks4oV4X2XHFTstXtO");
                // Complexity
                const ComplexityIndex = nodes.findIndex(item=>item.payload.doc.data()['project_map_field_id'] === "8Mwe89gcvBYNuOuurhVe");
                // Brand
                const BrandIndex = nodes.findIndex(item=>item.payload.doc.data()['project_map_field_id'] === "99KrwVmq0xNOnrYs3xoE");
                // Amount of Cabinets
                const AmountofCabinetsIndex = nodes.findIndex(item=>item.payload.doc.data()['project_map_field_id'] === "Aa0mO4IwJOBMq6t46EpL");
                // STEP 4
                // Installation Price
                const InstallationPriceIndex = nodes.findIndex(item=>item.payload.doc.data()['project_map_field_id'] === "KqpQgtO0iLNmLXy1Snv1");
                // Installation Linear Feet
                const InstallationLinearFeetIndex = nodes.findIndex(item=>item.payload.doc.data()['project_map_field_id'] === "QItLAnufGdO32DDttM8Y");
                // Installation Required
                const InstallationRequiredIndex = nodes.findIndex(item=>item.payload.doc.data()['project_map_field_id'] === "Qe60jcBLSkYneVSJHlVO");
                // Appliances Purchased
                const AppliancesPurchasedIndex = nodes.findIndex(item=>item.payload.doc.data()['project_map_field_id'] === "MYk4iyBUC7ov2ulmO82u");
                // STEP 7.5
                // Storage Fee Paid
                const StorageFeePaidIndex = nodes.findIndex(item=>item.payload.doc.data()['project_map_field_id'] === "coSlwfdlYRYfYMI3EwZX");
                // Storage Fee Cost
                const StorageFeeCostIndex = nodes.findIndex(item=>item.payload.doc.data()['project_map_field_id'] === "x2CpEcmvjvmP8LFsnnz7");
                // Step 8
                // Delivery Notes
                const DeliveryNotesIndex = nodes.findIndex(item=>item.payload.doc.data()['project_map_field_id'] === "FFtp0jOX2TKk9PY3ptpF");
                // Step 9
                // Installation Notes
                const InstallationNotesIndex = nodes.findIndex(item=>item.payload.doc.data()['project_map_field_id'] === "kwCZ4fNsd3OD7Ni30mW6");
                if(projectData.field_project_production_week.length === 0 || (projectData.field_project_production_week && projectData.field_project_production_week.und && nodes[desiredProductionWeekIndex].payload.doc.data()["value"] === projectData.field_project_production_week.und[0].value)){
                  if((projectData.field_requested_production_week.length ===0 && nodes[requestedProductionWeekIndex].payload.doc.data()['value'] === "") || (nodes[requestedProductionWeekIndex].payload.doc.data()['value'] === projectData.field_requested_production_week.und[0].value)){
                    if((projectData.field_project_size.length ===0 && nodes[SizeIndex].payload.doc.data()['value'] === "") || nodes[SizeIndex].payload.doc.data()['value'] === projectData.field_project_size.und[0].value){
                      if((projectData.field_project_acc_ref.length===0 && nodes[AccountingRefIndex].payload.doc.data()['value'] === "") || nodes[AccountingRefIndex].payload.doc.data()['value'] == projectData.field_project_acc_ref.und[0].value){
                        if((projectData.field_project_complexity.length === 0 && nodes[ComplexityIndex].payload.doc.data()['value'] ==="") || (projectData.field_project_complexity.und &&  nodes[ComplexityIndex].payload.doc.data()['value'] === projectData.field_project_complexity.und[0].value)){
                          if((projectData.field_project_brand.length === 0 && nodes[BrandIndex].payload.doc.data()['value'] ==="") || (projectData.field_project_complexity.und && nodes[BrandIndex].payload.doc.data()['value'] === projectData.field_project_brand.und[0].value)){
                            if((projectData.field_project_amount_of_cabinets.length ===0 && nodes[AmountofCabinetsIndex].payload.doc.data()['value'] === "") || nodes[AmountofCabinetsIndex].payload.doc.data()['value'] === projectData.field_project_amount_of_cabinets.und[0].value){
                              if((projectData.field_project_install_price.length ===0 && nodes[InstallationPriceIndex].payload.doc.data()['value'] === "" ) || nodes[InstallationPriceIndex].payload.doc.data()['value'] === projectData.field_project_install_price.und[0].value){
                                if((projectData.field_installation_linear_feet.length ===0 && nodes[InstallationLinearFeetIndex].payload.doc.data()['value'] === "") || nodes[InstallationLinearFeetIndex].payload.doc.data()['value'] === projectData.field_installation_linear_feet.und[0].value){
                                  if((projectData.field_installation_required.length ===0 && nodes[InstallationRequiredIndex].payload.doc.data()['value'] === "") || this.capitalizeFirstLetter(nodes[InstallationRequiredIndex].payload.doc.data()['value']) === projectData.field_installation_required.und[0].value){
                                    if((projectData.field_appliances_purchased.length ===0 && nodes[AppliancesPurchasedIndex].payload.doc.data()['value']==="") || nodes[AppliancesPurchasedIndex].payload.doc.data()['value'] === projectData.field_appliances_purchased.und[0].value){
                                      if((projectData.field_project_storage_fee_paid.length ===0 && nodes[StorageFeePaidIndex].payload.doc.data()['value'] === "") || nodes[StorageFeePaidIndex].payload.doc.data()['value'] === projectData.field_project_storage_fee_paid.und[0].value){
                                        if ((projectData.field_project_storage_fee_cost.length ===0 && nodes[StorageFeeCostIndex].payload.doc.data()['value'] === "") || nodes[StorageFeeCostIndex].payload.doc.data()['value'] === projectData.field_project_storage_fee_cost.und[0].value){
                                          if ((projectData.field_project_delivery_notes.length ===0 && nodes[DeliveryNotesIndex].payload.doc.data()['value'] === "") || nodes[DeliveryNotesIndex].payload.doc.data()['value'] === projectData.field_project_delivery_notes.und[0].value) {
                                            if((projectData.field_project_installation_notes.length ===0 && nodes[InstallationNotesIndex].payload.doc.data()['value'] === "") || nodes[InstallationNotesIndex].payload.doc.data()['value'] === projectData.field_project_installation_notes.und[0].value){
                                              console.log("all Node matched!!!!!!");
                                              this._common.showLoader(false);
                                            } else {
                                              this._alert.error('Installed notes not matching'+projectData.nid);   
                                              this._common.showLoader(false);
                                            }
                                          } else {
                                            this._alert.error('Deliver notes not matching'+projectData.nid); 
                                            this._common.showLoader(false);
                                          }
                                        } else {
                                          this._alert.error('Storage Fee Cost  not matching'+projectData.nid); 
                                          this._common.showLoader(false);
                                        }
                                      } else {
                                        this._alert.error('Storage Fee Paid not matching'+projectData.nid); 
                                        this._common.showLoader(false);
                                      }
                                    } else {
                                      this._alert.error('Appliances Purchased not matching'+projectData.nid); 
                                      this._common.showLoader(false);
                                    }
                                  } else {
                                    this._alert.error('Installation Required not matching'+projectData.nid); 
                                    this._common.showLoader(false);
                                  }
                                } else {
                                  this._alert.error('Installation Linear Feet not matching'+projectData.nid); 
                                  this._common.showLoader(false);
                                }
      
                              } else {
                                this._alert.error('Installation Price not matching '+projectData.nid);      
                                this._common.showLoader(false);
                              }
                            } else {
                              this._alert.error('Amount of cabinet not matching '+projectData.nid);      
                              this._common.showLoader(false);
                            }
      
                          } else {
                            this._alert.error('Brand not matching '+projectData.nid);      
                            this._common.showLoader(false);
                          }
      
                        } else {
                          this._alert.error('Complexity not matching '+projectData.nid);      
                          this._common.showLoader(false);
                        }
      
                      } else {
                        this._alert.error('Accounting ref not matching '+projectData.nid);    
                        this._common.showLoader(false);
                      }
      
                    } else {
                      this._alert.error('size not matching '+projectData.nid);    
                      this._common.showLoader(false);
                    }
      
                  } else {
                    this._alert.error('desired production week not matching '+projectData.nid);                
                    this._common.showLoader(false);
                  }
      
                }
                else {
                  this._alert.error('desired production week not matching '+projectData.nid);
                  this._common.showLoader(false);
      
                }
              } else {
                this._common.showLoader(false);
                this._alert.success('No Node available for the project!');
              }


              // return;
            },err =>{
              this._alert.error('Error occured while fetch project map node!');  
            });
          }
        }
        else {
          this._common.showLoader(false);
          this._alert.success('No project available for the designer!');

        }
      }, err=>{
        this._common.showLoader(false);
      })
    }

  }
*/
  /*
  // Match project collection data
  matchData(designer_id = ""){
    this._common.showLoader(true);
    if(designer_id === ""){

      this._admin.getAllProjects().subscribe(res=>{
        console.log(res.length,'res length!!!!');
          for(let i=13001; i<=14800; i++){
            let projectData = res[i].payload.doc.data()['rs2'];
          if(projectData.uid && res[i].payload.doc.data()['owner_contact_id'] === projectData.uid && res[i].payload.doc.data()['owner_user_id'] === projectData.uid && res[i].payload.doc.data()['author_user_id'] === projectData.uid){
            if(parseInt(projectData.created && res[i].payload.doc.data()['date_created']) === parseInt(projectData.created)*1000){
              console.log(projectData.nid,'!!!!!!!!!!!!!!! project id');
              // if(parseInt(projectData.changed && res[i].payload.doc.data()['date_updated']) === parseInt(projectData.changed)*1000){
                if(projectData.title && (res[i].payload.doc.data()['name'] === projectData.title || res[i].payload.doc.data()['name'] === "Kitchen")){
                  if(!projectData.field_project_acc_ref || projectData.field_project_acc_ref.length === 0 || (projectData.field_project_acc_ref.und[0].value && res[i].payload.doc.data()['accounting_ref'] === projectData.field_project_acc_ref.und[0].value) || projectData.field_project_acc_ref.und[0].value === null){
                    if(!projectData.field_h_project_client || projectData.field_h_project_client.length === 0 || (projectData.field_h_project_client && projectData.field_h_project_client.und && projectData.field_h_project_client.und[0].target_id && res[i].payload.doc.data()['contact_id'] === projectData.field_h_project_client.und[0].target_id)){
                      if(projectData.field_project_showroom_nid.length === 0  || (projectData.field_project_showroom_nid.und && projectData.field_project_showroom_nid.und[0].target_id && res[i].payload.doc.data()['showroom_id']=== projectData.field_project_showroom_nid.und[0].target_id)){
                        if(!projectData.field_project_budget || projectData.field_project_budget.length === 0 || (projectData.field_project_budget.und && projectData.field_project_budget.und[0].value && res[i].payload.doc.data()['budget'] === projectData.field_project_budget.und[0].value)){ // budget
                          if(!projectData.field_project_status || projectData.field_project_status.length === 0 || (projectData.field_project_status && projectData.field_project_status.und && projectData.field_project_status.und[0].tid && res[i].payload.doc.data()['status_id'] === projectData.field_project_status.und[0].tid)){ // status_id
                            if(projectData.field_project_requested_td || (projectData.field_project_requested_td.und && projectData.field_project_requested_td.und[0] && projectData.field_project_requested_td.und[0].value && (projectData.field_project_requested_td.und[0].value === res[i].payload.doc.data()['technical_designer_requested'] || projectData.field_project_requested_td.und[0].value === "Yes"))){ // technical_designer_requested
                              if(!projectData.field_project_production_week || projectData.field_project_production_week.length=== 0 || (projectData.field_project_production_week.und  && (res[i].payload.doc.data()['desired_production_week_added'] === projectData.field_project_production_week.und[0].value || res[i].payload.doc.data()['desired_production_week_added'] === "Yes")) || projectData.field_project_production_week.und[0].value === null){ // desired_production_week_added
                                if(!projectData.field_project_production_w_notes || projectData.field_project_production_w_notes.length === 0 || (projectData.field_project_production_w_notes.und && projectData.field_project_production_w_notes.und.length>0 && projectData.field_project_production_w_notes.und[0].value === res[i].payload.doc.data()['desired_production_week_comment'])){ // desired_production_week_comment
                                  if(!projectData.field_project_size || projectData.field_project_size.length === 0 || (projectData.field_project_size.und && projectData.field_project_size.und[0].value && res[i].payload.doc.data()['size_added'] === 'Yes')){
                                    if(!projectData.field_project_complexity || projectData.field_project_complexity.length === 0 || (projectData.field_project_complexity.und && projectData.field_project_complexity.und[0].value && res[i].payload.doc.data()['complexity_added'] === "Yes")){ // complexity_added
                                      if(!projectData.field_project_amount_of_cabinets || projectData.field_project_amount_of_cabinets.length === 0 || (projectData.field_project_amount_of_cabinets.und && projectData.field_project_amount_of_cabinets.und[0].value && res[i].payload.doc.data()['amount_of_cabinets_added'] === "Yes")){ // amount_of_cabinets_added
                                        if(!projectData.field_project_brand || projectData.field_project_brand.length === 0 || (projectData.field_project_brand.und && projectData.field_project_brand.und[0].value && res[i].payload.doc.data()['brand_added'] === "Yes")){ //brand_added
                                          if(!projectData.field_project_installation_d_rev || projectData.field_project_installation_d_rev.length=== 0 || (projectData.field_project_installation_d_rev.und && projectData.field_project_installation_d_rev.und[0].value && (res[i].payload.doc.data()['installation_plans_approved'] === "Yes" || projectData.field_project_installation_d_rev.und[0].value === res[i].payload.doc.data()['installation_plans_approved']))){ // installation_plans_approved
                                            if(!projectData.field_project_installation_d_rev || projectData.field_project_installation_d_rev.length === 0 || (projectData.field_project_installation_d_rev.und && projectData.field_project_installation_d_rev.und[0] && projectData.field_project_installation_d_rev.und[0].value && (projectData.field_project_installation_d_rev.und[0].value === res[i].payload.doc.data()['order_confirmation_approved'] || res[i].payload.doc.data()['order_confirmation_approved'] === "Yes"))){ // order_confirmation_approved
                                              if(!projectData.field_project_installation_d_rev || projectData.field_project_installation_d_rev.length=== 0 || (projectData.field_project_installation_d_rev && projectData.field_project_installation_d_rev.und && projectData.field_project_installation_d_rev.und[0] && (projectData.field_project_installation_d_rev.und[0].value ===  res[i].payload.doc.data()['perspectives_approved'] || res[i].payload.doc.data()['perspectives_approved'] === "Yes"))){ // perspectives_approved
                                                if(!projectData.field_project_installation_d_rev || projectData.field_project_installation_d_rev.length=== 0 || (projectData.field_project_installation_d_rev && projectData.field_project_installation_d_rev.und && projectData.field_project_installation_d_rev.und[0] && projectData.field_project_installation_d_rev.und[0].value && (projectData.field_project_installation_d_rev.und[0].value === res[i].payload.doc.data()['appliance_spec_package_approved'] || res[i].payload.doc.data()['appliance_spec_package_approved'] === "Yes"))){ //appliance_spec_package_approved
                                                  if(!projectData.field_project_sent_to_production || projectData.field_project_sent_to_production.length === 0 || (projectData.field_project_sent_to_production && projectData.field_project_sent_to_production.und && projectData.field_project_sent_to_production.und[0].value && projectData.field_project_sent_to_production.und[0].value  === res[i].payload.doc.data()['sent_to_production'])){ //sent_to_production
                                                    if(!projectData.field_project_delivery_requested || projectData.field_project_delivery_requested.length ===0 || (projectData.field_project_delivery_requested && projectData.field_project_delivery_requested.und && projectData.field_project_delivery_requested.und[0].value && projectData.field_project_delivery_requested.und[0].value === res[i].payload.doc.data()['delivery_requested']) || projectData.field_project_delivery_requested.und[0].value === null){ // delivery_requested
                                                      if(!projectData.field_project_request_t_des_revi || projectData.field_project_request_t_des_revi.length===0 || (projectData.field_project_request_t_des_revi && projectData.field_project_request_t_des_revi.und && projectData.field_project_request_t_des_revi.und[0].value && (projectData.field_project_request_t_des_revi.und[0].value === res[i].payload.doc.data()['step3_review_request_state'] || res[i].payload.doc.data()['step3_review_request_state'] === "Approved"))){ //step3_review_request_state
                                                        if(!projectData.field_step3_review_notes || projectData.field_step3_review_notes.length===0 || (projectData.field_step3_review_notes && projectData.field_step3_review_notes.und && projectData.field_step3_review_notes.und[0].value && projectData.field_step3_review_notes.und[0].value === res[i].payload.doc.data()['step3_review_request_comment'])) { //step3_review_request_comment
                                                          if(!projectData.field_project_contract_review || projectData.field_project_contract_review.length === 0 || ( projectData.field_project_contract_review && projectData.field_project_contract_review.und && projectData.field_project_contract_review.und[0].value && (this.capitalizeFirstLetter(projectData.field_project_contract_review.und[0].value) === res[i].payload.doc.data()['step4_review_request_state'] || res[i].payload.doc.data()['step4_review_request_state'] === "Approved")) || projectData.field_project_contract_review.und[0].value === null){ //step4_review_request_state
                                                            if(!projectData.field_step4_review_notes || projectData.field_step4_review_notes.length===0 || (projectData.field_step4_review_notes && projectData.field_step4_review_notes.und && projectData.field_step4_review_notes.und[0].value && projectData.field_step4_review_notes.und[0].value === res[i].payload.doc.data()['step4_review_request_comment'])){ // step4_review_request_comment
                                                              if(!projectData.field_project_signed_final_revie || projectData.field_project_signed_final_revie.length=== 0 || (projectData.field_project_signed_final_revie && projectData.field_project_signed_final_revie.und && projectData.field_project_signed_final_revie.und[0].value && (this.capitalizeFirstLetter(projectData.field_project_signed_final_revie.und[0].value) === res[i].payload.doc.data()['step5_review_request_state'] || res[i].payload.doc.data()['step5_review_request_state'] === "Approved"))){ //step5_review_request_state
                                                                if(!projectData.field_step5_review_notes || projectData.field_step5_review_notes.length === 0 || (projectData.field_step5_review_notes && projectData.field_step5_review_notes.und && projectData.field_step5_review_notes.und.length>0 && projectData.field_step5_review_notes.und[0].value === res[i].payload.doc.data()['step5_review_request_comment'])) { // step5_review_request_comment
                                                                  if(!projectData.field_project_installation_d_rev || projectData.field_project_installation_d_rev.length === 0 || (projectData.field_project_installation_d_rev && projectData.field_project_installation_d_rev.und && projectData.field_project_installation_d_rev.und[0].value && (this.capitalizeFirstLetter(projectData.field_project_installation_d_rev.und[0].value) === res[i].payload.doc.data()['step6_review_request_state'] || res[i].payload.doc.data()['step6_review_request_state'] === "Approved"))){ // step6_review_request_state
                                                                    if(!projectData.field_step6_review_notes || projectData.field_step6_review_notes.length === 0 || (projectData.field_step6_review_notes && projectData.field_step6_review_notes.und && projectData.field_step6_review_notes.und[0].value && projectData.field_step6_review_notes.und[0].value === res[i].payload.doc.data()['step6_review_request_comment'])) { // step6_review_request_comment
                                                                      if(!projectData.field_pre_delivery_inform_review || projectData.field_pre_delivery_inform_review.length ===0 || (projectData.field_pre_delivery_inform_review && projectData.field_pre_delivery_inform_review.und && projectData.field_pre_delivery_inform_review.und[0] && projectData.field_pre_delivery_inform_review.und[0].value && (this.capitalizeFirstLetter(projectData.field_pre_delivery_inform_review.und[0].value) === res[i].payload.doc.data()['step7_5_review_request_state'] || res[i].payload.doc.data()['step7_5_review_request_state'] === "Approved")) || projectData.field_pre_delivery_inform_review.und[0].value === null){ // step7_5_review_request_state
                                                                        if(!projectData.field_step7_5_review_notes || projectData.field_step7_5_review_notes.length === 0 || (projectData.field_step7_5_review_notes && projectData.field_step7_5_review_notes.und && projectData.field_step7_5_review_notes.und[0].value === res[i].payload.doc.data()['step7_5_review_request_comment'])){ //step7_5_review_request_comment
                                                                          if(!projectData.field_service_parts_form_informa || projectData.field_service_parts_form_informa.length === 0 || (projectData.field_service_parts_form_informa && projectData.field_service_parts_form_informa.und && projectData.field_service_parts_form_informa.und[0].value && (projectData.field_service_parts_form_informa.und[0].value === res[i].payload.doc.data()['step9_review_request_state'] || res[i].payload.doc.data()['step9_review_request_state'] === "Approved"))){ // step9_review_request_state
                                                                            if(!projectData.field_step_9_review_notes || projectData.field_step_9_review_notes.length === 0 || (projectData.field_step_9_review_notes && projectData.field_step_9_review_notes.und && projectData.field_step_9_review_notes.und[0].value && projectData.field_step_9_review_notes.und[0].value === res[i].payload.doc.data()['step9_review_request_comment'])) { //step9_review_request_comment
                                                                              console.log('data matched!', i);
                                                                              // Fetch data from project_map_nodes for current project...
                                                                              // this._project.getProjectMapNode(projectData.nid).subscribe(res1=>{
                                                                              //   console.log(res1[0].payload.doc.data(),'res1 res[pmse!!!!!'); 
                                                                              //   return;

                                                                              // },err =>{
                                                                              //   this._alert.error('Error occured while fetch project map node!');  
                                                                              // })
                                                                            } else {
                                                                              this._alert.error('step9_review_request_comment not matching '+projectData.nid);
                                                                              break;      
                                                                            }

                                                                          } else {
                                                                            this._alert.error('step9_review_request_state not matching '+projectData.nid);
                                                                            break;    
                                                                          }

                                                                        } else {
                                                                          this._alert.error('step7_5_review_request_comment not matching '+projectData.nid);
                                                                          break;    
  
                                                                        }

                                                                      } else {
                                                                        this._alert.error('step7_5_review_request_state not matching '+projectData.nid);
                                                                        break;    
                                                                      }

                                                                    } else {
                                                                      this._alert.error('step6_review_request_comment not matching '+projectData.nid);
                                                                      break;  
                                                                    }

                                                                  } else {
                                                                    this._alert.error('step6_review_request_state not matching '+projectData.nid);
                                                                    break;  
                                                                  }
                                                                } else {
                                                                  this._alert.error('step5_review_request_comment not matching '+projectData.nid);
                                                                  break;
                                                                }

                                                              } else {
                                                                this._alert.error('step5_review_request_state not matching '+projectData.nid);
                                                                break;
                                                              }

                                                            } else {
                                                              this._alert.error('step4_review_request_comment not matching '+projectData.nid);
                                                              break;
                                                            }

                                                          } else {
                                                            this._alert.error('step4_review_request_state not matching '+projectData.nid);
                                                            break;
  
                                                          }

                                                        } else {
                                                          this._alert.error('step3_review_request_comment not matching '+projectData.nid);
                                                          break;
                                                        }


                                                      } else {
                                                        this._alert.error('step3_review_request_state not matching '+projectData.nid);
                                                        break;
                                                      }

                                                    } else {
                                                      this._alert.error('delivery_requested not matching '+projectData.nid);
                                                      break;
                                                    }

                                                  } else {
                                                    this._alert.error('sent_to_production not matching '+projectData.nid);
                                                    break;
                                                    }
                                                } else {
                                                  this._alert.error('appliance_spec_package_approved not matching '+projectData.nid);
                                                  break;
                                                }

                                              } else {
                                                this._alert.error('perspectives_approved not matching '+projectData.nid);
                                                break;    
                                              }

                                            } else {
                                              this._alert.error('order_confirmation_approved not matching '+projectData.nid);
                                              break;    
                                            }
                                            

                                          } else {
                                            this._alert.error('installation_plans_approved not matching '+projectData.nid);
                                            break;  
  
                                          }


                                        } else {
                                          this._alert.error('brand_added not matching '+projectData.nid);
                                          break;  
                                        }

                                      } else {
                                        this._alert.error('amount_of_cabinets_added not matching '+projectData.nid);
                                        break;  
                                      }

                                    } else {
                                      this._alert.error('complexity_added not matching '+projectData.nid);
                                      break;  
                                    }

                                  } else {
                                    this._alert.error('size_added not matching '+projectData.nid);
                                    break;  
                                  }
                                } else {
                                  this._alert.error('desired_production_week_comment not matching '+projectData.nid);
                                  break;  
                                }


                              } else {
                                this._alert.error('desired_production_week_added not matching '+projectData.nid);
                                break;  
                              }


                            } else {
                              this._alert.error('technical_designer_requested not matching '+projectData.nid);
                              break;  
                            }

                          }else {
                            this._alert.error('status_id not matching '+projectData.nid);
                            break;  
                            }

                        }else{
                          this._alert.error('budget not matching '+projectData.nid);
                          break;  
                        }

                      }else {
                        this._alert.error('showroom_id not matching '+projectData.nid);
                        break;
                      }

                    }
                    else {
                      this._alert.error('contact_id not matching '+projectData.nid);
                      break;
                    }
                  }
                  else {
                    this._alert.error('accounting_ref not matching '+projectData.nid);
                    break;
                  }
                }else {
                  this._alert.error('name not matching '+projectData.nid);    
                  break;
                }

              // } else {
              //   this._alert.error('date_updated not matching');  
              //   break;
              // }
            }
            else {
              this._alert.error('date_created not matching '+projectData.nid);
              break;
            }
          }
          else {
            this._alert.error('owner_contact_id or owner_user_id or author_user_id not matching '+projectData.nid);
            break;
          }



          }  
  
  
      },err=>{
        console.log('this is error',err);
      }) 

      

    }else {
      // Fetch all the projects of designer...
      this._project.getDesignerProjects(designer_id).subscribe(res=>{
        this._common.showLoader(false);
        console.log(res.length ,'designer total projects');
        for(let i=0; i < res.length; i++){
          let projectData = res[i].payload.doc.data()['rs2'];
           
          if(projectData.uid && res[i].payload.doc.data()['owner_contact_id'] === projectData.uid && res[i].payload.doc.data()['owner_user_id'] === projectData.uid && res[i].payload.doc.data()['author_user_id'] === projectData.uid){
            if(parseInt(projectData.created && res[i].payload.doc.data()['date_created']) === parseInt(projectData.created)*1000){
              console.log(projectData.nid,'project id!');
              // if(parseInt(projectData.changed && res[i].payload.doc.data()['date_updated']) === parseInt(projectData.changed)*1000){
                if(projectData.title && (res[i].payload.doc.data()['name'] === projectData.title || res[i].payload.doc.data()['name'] === "Kitchen")){
                  if(!projectData.field_project_acc_ref || projectData.field_project_acc_ref.length === 0 || (projectData.field_project_acc_ref.und[0].value && res[i].payload.doc.data()['accounting_ref'] === projectData.field_project_acc_ref.und[0].value)  || projectData.field_project_acc_ref.und[0].value === null){
                    if(projectData.field_h_project_client && projectData.field_h_project_client.und && projectData.field_h_project_client.und[0].target_id && res[i].payload.doc.data()['contact_id'] === projectData.field_h_project_client.und[0].target_id){
                      if(projectData.field_project_showroom_nid.length === 0  || (projectData.field_project_showroom_nid.und && projectData.field_project_showroom_nid.und[0].target_id && res[i].payload.doc.data()['showroom_id']=== projectData.field_project_showroom_nid.und[0].target_id)){
                        if(!projectData.field_project_budget || projectData.field_project_budget.length === 0 || (projectData.field_project_budget.und && projectData.field_project_budget.und[0].value && res[i].payload.doc.data()['budget'] === projectData.field_project_budget.und[0].value)){ // budget
                          if(projectData.field_project_status && projectData.field_project_status.und && projectData.field_project_status.und[0].tid && res[i].payload.doc.data()['status_id'] === projectData.field_project_status.und[0].tid){ // status_id
                            if(projectData.field_project_requested_td || (projectData.field_project_requested_td.und && projectData.field_project_requested_td.und[0] && projectData.field_project_requested_td.und[0].value && (projectData.field_project_requested_td.und[0].value === res[i].payload.doc.data()['technical_designer_requested'] || projectData.field_project_requested_td.und[0].value === "Yes"))){ // technical_designer_requested
                              if(!projectData.field_project_production_week || projectData.field_project_production_week.length=== 0 || (projectData.field_project_production_week.und  && (res[i].payload.doc.data()['desired_production_week_added'] === projectData.field_project_production_week.und[0].value || res[i].payload.doc.data()['desired_production_week_added'] === "Yes")) || projectData.field_project_production_week.und[0].value === null){ // desired_production_week_added
                                if(!projectData.field_project_production_w_notes || projectData.field_project_production_w_notes.length === 0 || (projectData.field_project_production_w_notes.und && projectData.field_project_production_w_notes.und.length>0 && projectData.field_project_production_w_notes.und[0].value === res[i].payload.doc.data()['desired_production_week_comment'])){ // desired_production_week_comment
                                  if(!projectData.field_project_size || projectData.field_project_size.length === 0 || (projectData.field_project_size.und && projectData.field_project_size.und[0].value && res[i].payload.doc.data()['size_added'] === 'Yes')){
                                    if(!projectData.field_project_complexity || projectData.field_project_complexity.length === 0 || (projectData.field_project_complexity.und && projectData.field_project_complexity.und[0].value && res[i].payload.doc.data()['complexity_added'] === "Yes")){ // complexity_added
                                      if(!projectData.field_project_amount_of_cabinets || projectData.field_project_amount_of_cabinets.length === 0 || (projectData.field_project_amount_of_cabinets.und && projectData.field_project_amount_of_cabinets.und[0].value && res[i].payload.doc.data()['amount_of_cabinets_added'] === "Yes")){ // amount_of_cabinets_added
                                        if(!projectData.field_project_brand || projectData.field_project_brand.length === 0 || (projectData.field_project_brand.und && projectData.field_project_brand.und[0].value && res[i].payload.doc.data()['brand_added'] === "Yes")){ //brand_added
                                          if(!projectData.field_project_installation_d_rev || projectData.field_project_installation_d_rev.length=== 0 || (projectData.field_project_installation_d_rev.und && projectData.field_project_installation_d_rev.und[0].value && (res[i].payload.doc.data()['installation_plans_approved'] === "Yes" || projectData.field_project_installation_d_rev.und[0].value === res[i].payload.doc.data()['installation_plans_approved']))){ // installation_plans_approved
                                            if(!projectData.field_project_installation_d_rev || projectData.field_project_installation_d_rev.length === 0 || (projectData.field_project_installation_d_rev.und && projectData.field_project_installation_d_rev.und[0] && projectData.field_project_installation_d_rev.und[0].value && (projectData.field_project_installation_d_rev.und[0].value === res[i].payload.doc.data()['order_confirmation_approved'] || res[i].payload.doc.data()['order_confirmation_approved'] === "Yes"))){ // order_confirmation_approved
                                              if(!projectData.field_project_installation_d_rev || projectData.field_project_installation_d_rev.length=== 0 || (projectData.field_project_installation_d_rev && projectData.field_project_installation_d_rev.und && projectData.field_project_installation_d_rev.und[0] && (projectData.field_project_installation_d_rev.und[0].value ===  res[i].payload.doc.data()['perspectives_approved'] || res[i].payload.doc.data()['perspectives_approved'] === "Yes"))){ // perspectives_approved
                                                if(!projectData.field_project_installation_d_rev || projectData.field_project_installation_d_rev.length=== 0 || (projectData.field_project_installation_d_rev && projectData.field_project_installation_d_rev.und && projectData.field_project_installation_d_rev.und[0] && projectData.field_project_installation_d_rev.und[0].value && (projectData.field_project_installation_d_rev.und[0].value === res[i].payload.doc.data()['appliance_spec_package_approved'] || res[i].payload.doc.data()['appliance_spec_package_approved'] === "Yes"))){ //appliance_spec_package_approved
                                                  if(!projectData.field_project_sent_to_production || projectData.field_project_sent_to_production.length === 0 || (projectData.field_project_sent_to_production && projectData.field_project_sent_to_production.und && projectData.field_project_sent_to_production.und[0].value && projectData.field_project_sent_to_production.und[0].value  === res[i].payload.doc.data()['sent_to_production'])){ //sent_to_production
                                                    if(!projectData.field_project_delivery_requested || projectData.field_project_delivery_requested.length ===0 || (projectData.field_project_delivery_requested && projectData.field_project_delivery_requested.und && projectData.field_project_delivery_requested.und[0].value && projectData.field_project_delivery_requested.und[0].value === res[i].payload.doc.data()['delivery_requested']) || projectData.field_project_delivery_requested.und[0].value === null){ // delivery_requested
                                                      if(!projectData.field_project_request_t_des_revi || projectData.field_project_request_t_des_revi.length===0 || (projectData.field_project_request_t_des_revi && projectData.field_project_request_t_des_revi.und && projectData.field_project_request_t_des_revi.und[0].value && (projectData.field_project_request_t_des_revi.und[0].value === res[i].payload.doc.data()['step3_review_request_state'] || res[i].payload.doc.data()['step3_review_request_state'] === "Approved"))){ //step3_review_request_state
                                                        if(!projectData.field_step3_review_notes || projectData.field_step3_review_notes.length===0 || (projectData.field_step3_review_notes && projectData.field_step3_review_notes.und && projectData.field_step3_review_notes.und[0].value && projectData.field_step3_review_notes.und[0].value === res[i].payload.doc.data()['step3_review_request_comment'])) { //step3_review_request_comment
                                                          if(!projectData.field_project_contract_review || projectData.field_project_contract_review.length === 0 || ( projectData.field_project_contract_review && projectData.field_project_contract_review.und && projectData.field_project_contract_review.und[0].value && (this.capitalizeFirstLetter(projectData.field_project_contract_review.und[0].value) === res[i].payload.doc.data()['step4_review_request_state'] || res[i].payload.doc.data()['step4_review_request_state'] === "Approved")) || projectData.field_project_contract_review.und[0].value === null){ //step4_review_request_state
                                                            if(!projectData.field_step4_review_notes || projectData.field_step4_review_notes.length===0 || (projectData.field_step4_review_notes && projectData.field_step4_review_notes.und && projectData.field_step4_review_notes.und[0].value && projectData.field_step4_review_notes.und[0].value === res[i].payload.doc.data()['step4_review_request_comment'])){ // step4_review_request_comment
                                                              if(!projectData.field_project_signed_final_revie || projectData.field_project_signed_final_revie.length=== 0 || (projectData.field_project_signed_final_revie && projectData.field_project_signed_final_revie.und && projectData.field_project_signed_final_revie.und[0].value && (projectData.field_project_signed_final_revie.und[0].value === res[i].payload.doc.data()['step5_review_request_state'] || res[i].payload.doc.data()['step5_review_request_state'] === "Approved"))){ //step5_review_request_state
                                                                if(!projectData.field_step5_review_notes || projectData.field_step5_review_notes.length === 0 || (projectData.field_step5_review_notes && projectData.field_step5_review_notes.und && projectData.field_step5_review_notes.und.length>0 && projectData.field_step5_review_notes.und[0].value === res[i].payload.doc.data()['step5_review_request_comment'])) { // step5_review_request_comment
                                                                  if(!projectData.field_project_installation_d_rev || projectData.field_project_installation_d_rev.length === 0 || (projectData.field_project_installation_d_rev && projectData.field_project_installation_d_rev.und && projectData.field_project_installation_d_rev.und[0].value && (projectData.field_project_installation_d_rev.und[0].value === res[i].payload.doc.data()['step6_review_request_state'] || res[i].payload.doc.data()['step6_review_request_state'] === "Approved"))){ // step6_review_request_state
                                                                    if(!projectData.field_step6_review_notes || projectData.field_step6_review_notes.length === 0 || (projectData.field_step6_review_notes && projectData.field_step6_review_notes.und && projectData.field_step6_review_notes.und[0].value && projectData.field_step6_review_notes.und[0].value === res[i].payload.doc.data()['step6_review_request_comment'])) { // step6_review_request_comment
                                                                      if(!projectData.field_pre_delivery_inform_review || projectData.field_pre_delivery_inform_review.length ===0 || (projectData.field_pre_delivery_inform_review && projectData.field_pre_delivery_inform_review.und && projectData.field_pre_delivery_inform_review.und[0] && projectData.field_pre_delivery_inform_review.und[0].value && (this.capitalizeFirstLetter(projectData.field_pre_delivery_inform_review.und[0].value) === res[i].payload.doc.data()['step7_5_review_request_state'] || res[i].payload.doc.data()['step7_5_review_request_state'] === "Approved")) || projectData.field_pre_delivery_inform_review.und[0].value === null){ // step7_5_review_request_state
                                                                        if(!projectData.field_step7_5_review_notes || projectData.field_step7_5_review_notes.length === 0 || (projectData.field_step7_5_review_notes && projectData.field_step7_5_review_notes.und && projectData.field_step7_5_review_notes.und[0].value === res[i].payload.doc.data()['step7_5_review_request_comment'])){ //step7_5_review_request_comment
                                                                          if(!projectData.field_service_parts_form_informa || projectData.field_service_parts_form_informa.length === 0 || (projectData.field_service_parts_form_informa && projectData.field_service_parts_form_informa.und && projectData.field_service_parts_form_informa.und[0].value && (projectData.field_service_parts_form_informa.und[0].value === res[i].payload.doc.data()['step9_review_request_state'] || res[i].payload.doc.data()['step9_review_request_state'] === "Approved"))){ // step9_review_request_state
                                                                            if(!projectData.field_step_9_review_notes || projectData.field_step_9_review_notes.length === 0 || (projectData.field_step_9_review_notes && projectData.field_step_9_review_notes.und && projectData.field_step_9_review_notes.und[0].value && projectData.field_step_9_review_notes.und[0].value === res[i].payload.doc.data()['step9_review_request_comment'])) { //step9_review_request_comment
                                                                              console.log('data matched of project data!');
                                                                             
                                                                            } else {
                                                                              this._alert.error('step9_review_request_comment not matching '+projectData.nid);
                                                                              break;      
                                                                            }

                                                                          } else {
                                                                            this._alert.error('step9_review_request_state not matching '+projectData.nid);
                                                                            break;    
                                                                          }

                                                                        } else {
                                                                          this._alert.error('step7_5_review_request_comment not matching '+projectData.nid);
                                                                          break;    
  
                                                                        }

                                                                      } else {
                                                                        this._alert.error('step7_5_review_request_state not matching '+projectData.nid);
                                                                        break;    
                                                                      }

                                                                    } else {
                                                                      this._alert.error('step6_review_request_comment not matching '+projectData.nid);
                                                                      break;  
                                                                    }

                                                                  } else {
                                                                    this._alert.error('step6_review_request_state not matching '+projectData.nid);
                                                                    break;  
                                                                  }
                                                                } else {
                                                                  this._alert.error('step5_review_request_comment not matching '+projectData.nid);
                                                                  break;
                                                                }

                                                              } else {
                                                                this._alert.error('step5_review_request_state not matching '+projectData.nid);
                                                                break;
                                                              }

                                                            } else {
                                                              this._alert.error('step4_review_request_comment not matching '+projectData.nid);
                                                              break;
                                                            }

                                                          } else {
                                                            this._alert.error('step4_review_request_state not matching '+projectData.nid);
                                                            break;
  
                                                          }

                                                        } else {
                                                          this._alert.error('step3_review_request_comment not matching '+projectData.nid);
                                                          break;
                                                        }


                                                      } else {
                                                        this._alert.error('step3_review_request_state not matching '+projectData.nid);
                                                        break;
                                                      }

                                                    } else {
                                                      this._alert.error('delivery_requested not matching '+projectData.nid);
                                                      break;
                                                    }

                                                  } else {
                                                    this._alert.error('sent_to_production not matching '+projectData.nid);
                                                    break;
                                                    }
                                                } else {
                                                  this._alert.error('appliance_spec_package_approved not matching '+projectData.nid);
                                                  break;
                                                }

                                              } else {
                                                this._alert.error('perspectives_approved not matching '+projectData.nid);
                                                break;    
                                              }

                                            } else {
                                              this._alert.error('order_confirmation_approved not matching '+projectData.nid);
                                              break;    
                                            }
                                            

                                          } else {
                                            this._alert.error('installation_plans_approved not matching '+projectData.nid);
                                            break;  
  
                                          }


                                        } else {
                                          this._alert.error('brand_added not matching '+projectData.nid);
                                          break;  
                                        }

                                      } else {
                                        this._alert.error('amount_of_cabinets_added not matching '+projectData.nid);
                                        break;  
                                      }

                                    } else {
                                      this._alert.error('complexity_added not matching '+projectData.nid);
                                      break;  
                                    }

                                  } else {
                                    this._alert.error('size_added not matching '+projectData.nid);
                                    break;  
                                  }
                                } else {
                                  this._alert.error('desired_production_week_comment not matching '+projectData.nid);
                                  break;  
                                }


                              } else {
                                this._alert.error('desired_production_week_added not matching '+projectData.nid);
                                break;  
                              }


                            } else {
                              this._alert.error('technical_designer_requested not matching '+projectData.nid);
                              break;  
                            }

                          }else {
                            this._alert.error('status_id not matching '+projectData.nid);
                            break;  
                            }

                        }else{
                          this._alert.error('budget not matching '+projectData.nid);
                          break;  
                        }

                      }else {
                        this._alert.error('showroom_id not matching '+projectData.nid);
                        break;
                      }

                    }
                    else {
                      this._alert.error('contact_id not matching '+projectData.nid);
                      break;
                    }
                  }
                  else {
                    this._alert.error('accounting_ref not matching '+projectData.nid);
                    break;
                  }
                }else {
                  this._alert.error('name not matching '+projectData.nid);    
                  break;
                }

              // } else {
              //   this._alert.error('date_updated not matching');  
              //   break;
              // }
            }
            else {
              this._alert.error('date_created not matching '+projectData.nid);
              break;
            }
          }
          else {
            this._alert.error('owner_contact_id or owner_user_id or author_user_id not matching '+projectData.nid);
            break;
          }
        }
      },err=>{
        console.log(err,'error occured while fetching designer projects')
        this._alert.error(err.error && err.error.message?err.error.message:'Something went wrong!');
      })
      
    }
  }
*/
  ngOnDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
  }
}
